import { sortBy } from 'lodash';

const formatTimeZones = tz => {
  const timezoneOptions = sortBy(
    tz.map(t => {
      const tzOption = {
        ...t,
        ...{
          id: t.timeZoneName,
          key: t.timeZoneName,
          label: `(UTC${t.timeZoneOffset}) ${t.timeZoneName}`,
          value: t.timeZoneId,
        },
      };

      return tzOption;
    }),
    'label',
  );

  return timezoneOptions;
};

export default formatTimeZones;
